<div class="">
  <label id="lbl-{{dtaQuestions.name}}" class="lbl lbl-question"for="{{dtaQuestions.name}}">{{dtaQuestions.name}}</label>
  <input type="{{dtaQuestions.type}}"  class="presenter" id="{{dtaQuestions.name}}" name="{{dtaQuestions.name}}" maxlength="" step="" min="" max="" value="{{dtaQuestions.answers}}" placeholder="{{dtaQuestions.description}}">
</div>
